export class EconomicalGroupDetailModel {
  idEconomicGroup?: number;
  campaigns: Campaign[] = [];
}

export class Campaign {
  idCampaign: number = 0;
  description: string = '';
  hasMdrFlex: boolean = false;
  hasMdr: boolean = false;
  mdrWithPrepayment: boolean = false;
  mdrRates: MdrOrMdrFlexRateDto[] = [];
  mdrFlexRates: MdrOrMdrFlexRateDto[] = [];
  autoPrepayment: AutoPrepaymentEG = new AutoPrepaymentEG();
  availableTechnologies: TechnologyPriceDataModel[] = [];
}

export class AutoPrepaymentEG {
  suggestedAutoPrepayment: number = 0;
  maxAnnualBilling: number = 0;
}

export class MdrOrMdrFlexRateDto {
  bandeira: string = '';
  debito: number = 0;
  credito: number = 0;
  parcelamentoAte6x: number = 0;
  parcelamentoMais6x: number = 0;
  crediario: number = 0;
}

export class TechnologyPriceDataModel {
  public technology: string = '';
  public price: number = 0;
}

export interface CampaignTab {
  description: string;
  mdrRateDataSource: MdrOrMdrFlexRateDto[];
  mdrFlexRateDataSource: MdrOrMdrFlexRateDto[];
  hasMdrRate: boolean;
  hasMdrFlexRate: boolean;
  mdrWithPrepayment: boolean;
  autoPrepayment: AutoPrepaymentEG;
  availableTechnologies: TechnologyPriceDataModel[];
}
